import wrapperLocalStorage from './localStorage.functions'

const localStorage = wrapperLocalStorage()

export default localStorage
